import React from "react";

export const BusesSection = props => {
  return (
    <tbody>
      {props.citytransport.length > 0 ? (props.citytransport.slice(0, 5).map(schedule => (
        <tr className="timetable-row">
          <td className="timetable-departure">{schedule.estimatedTime}</td>
          <td className="citytransport-destination">{schedule.headsign}</td>
          <td className="timetable-departure">{schedule.routeId}</td>
          <td className="citytransport-type">{schedule.typ}</td>
        </tr>
      ))) : (<tr>
      <td colSpan='3' >
        <div>
          W najbliższym czasie brak połączeń komunikacji miejskiej.
        </div>
        
      </td>
      </tr>)}
    </tbody>
  );
};
